import { useState } from 'react';

import { InternalModule, MAX_COLLAPSED, PANEL_HEIGHT, EXPANDED_HEIGHT } from '../launch.constants';
import { Panel, PanelHeader, PanelTitle, PanelSubtitle, PanelFooter, ListContainer } from '../styles';
import { ModuleRow } from './ModuleRow';

interface ModulesPanelProps {
  modules: InternalModule[];
  onOpenModule: (path: string) => void;
}

export const ModulesPanel = ({ modules, onOpenModule }: ModulesPanelProps) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Panel style={{
      height: expanded ? EXPANDED_HEIGHT : PANEL_HEIGHT,
      maxHeight: 'calc(100vh - 220px)',
    }}>
      <PanelHeader>
        <PanelTitle>Módulos</PanelTitle>
        <PanelSubtitle>Herramientas internas de Polynator</PanelSubtitle>
      </PanelHeader>

      <ListContainer data-scrollable={expanded ? 'true' : undefined}>
        {modules.map((mod) => (
          <ModuleRow key={mod.id} module={mod} onOpen={onOpenModule} />
        ))}
      </ListContainer>

      {modules.length > MAX_COLLAPSED && (
        <PanelFooter onClick={() => setExpanded((v) => !v)}>
          {expanded ? 'Ver menos ↑' : `Ver todos (${modules.length}) →`}
        </PanelFooter>
      )}
    </Panel>
  );
};
